import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './auth/Auth0ProviderWithNavigate';
import { AppErrorBoundary } from './components/error-boundary/AppErrorBoundary';
import App from './App';
import './index.css';
import { initializeCoreWebVitals } from './utils/coreWebVitals';
import { initializeGlobalErrorReporting } from './utils/errorReporting';
import { initializeConfigValidation } from './utils/configValidation';
import { setupConsoleFilters } from './utils/consoleFilter';

// Validate telemetry configuration (must run before initializing error reporting).
initializeConfigValidation();

// Setup console filters for development
setupConsoleFilters();

// Initialize error reporting and web vitals (must run after config validation).
initializeGlobalErrorReporting();
initializeCoreWebVitals();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </BrowserRouter>
      </HelmetProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);

// Add boot confirmation
console.info('[rm-ui] boot ok');
